<template>
  <div>
    <div class="primary-background py-3">
      <div class="container">
        <div class="d-flex justify-content-end">
          <ol class="breadcrumb text-align-right">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li v-if="$route.query.reDirectFrom && this.$route.query.reDirectFrom !== 'link'" class="breadcrumb-item">
              <a class="cursor-pointer" @click="reDirectTo()">{{ $route.query.reDirectFrom | capitalize }}</a>
            </li>
            <li class="breadcrumb-item active">
              {{ loadingData ? "..." : peopleData.person.name }}
            </li>
          </ol>
        </div>
      </div>
    </div>
    <div>
      <div class="primary-background mb-2">
        <personal-detail-section :people-data="peopleData" :is-user-loading="loadingData" />
      </div>
      <div class="container">
        <line-loader v-if="loadingData" :size="3" />
        <div v-else>
          <b-card v-if="peopleData.person.biography">
            <div class="lyon-display-medium-24 mb-3">Biography</div>
            <div class="regular-16" v-html="peopleData.person.biography" />
          </b-card>
          <div v-if="canAccessPublicAndAdmin()">
            <b-card>
              <div class="lyon-display-medium-24 mb-3">
                Contact Information
                <a :href="fetchLegacyUrl(`/people/${$route.params.id}/contacts`)">
                  <i v-b-tooltip.hover class="fa fa-edit edit-icon" title="Edit/Add Contact" />
                </a>
              </div>
              <div v-if="!peopleData.person.email">
                <span class="text-muted regular-14">No Contact Information provided</span>
              </div>
              <div v-else>
                <div class="row mb-3">
                  <div class="col-md-2">
                    <span class="text-muted regular-16">Login email</span>
                  </div>
                  <div class="col-md-10">
                    <div class="regular-16">
                      <a :href="'mailto:' + peopleData.person.email">{{ peopleData.person.email }}</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-2">
                <div class="col-md-12">
                  <b-btn v-b-modal="'showUpdateEmailForm'" variant="primary" size="sm" class="mb-2">
                    Update Email
                  </b-btn>
                  <b-btn v-b-modal="'showUpdatePasswordForm'" variant="primary" size="sm" class="mb-2">
                    Update Password
                  </b-btn>
                  <b-btn v-if="canEditCms" v-b-modal="'showUpdateOrcidForm'" variant="primary" size="sm" class="mb-2">
                    Update ORCID
                  </b-btn>
                </div>
                <b-modal id="showUpdateEmailForm" ref="showUpdateEmailForm" size="lg" centered hide-footer
                         title="Update Email" no-close-on-backdrop no-close-on-esc>
                  <update-email-form :person-data="peopleData.person" @updateEmailData="updateEmailData" />
                </b-modal>
                <b-modal id="showUpdatePasswordForm" ref="showUpdatePasswordForm" size="lg" centered hide-footer
                         title="Update Password" no-close-on-backdrop no-close-on-esc>
                  <update-password-form :person-data="peopleData.person" @updatePasswordData="updatePasswordData" />
                </b-modal>
                <b-modal id="showUpdateOrcidForm" ref="showUpdateOrcidForm" size="lg" centered hide-footer
                         title="Update ORCID" no-close-on-backdrop no-close-on-esc>
                  <update-oRCID-form :person-data="peopleData.person" :access-by-admin="'true'"
                                     @updateORCIDData="updateORCIDData" />
                </b-modal>
              </div>
              <hr>
              <div v-if="personAllContacts.length === 0">
                <span class="text-muted regular-14">No Other Contact Information provided</span>
              </div>
              <div v-else>
                <div v-for="(personOtherContact, index) in personAllContacts" :key="index" class="row mb-3">
                  <div class="col-md-12">
                    <span class="regular-16 mr-2">{{ index + 1 }}.</span>
                    <span class="regular-16 mr-2">{{ personOtherContact.contact_category }}</span>
                    <span class="regular-16">{{ personOtherContact.contact_type }} : </span>
                    <span v-if="personOtherContact.contact_type === 'Email'" class="regular-16"
                          :class="personOtherContact.inactive ? 'strikethrough-text' : ''">
                      <a :href="'mailto:' + personOtherContact.value">{{ personOtherContact.value }}</a>
                    </span>
                    <span v-else class="regular-16">
                      <span class="regular-16" :class="personOtherContact.inactive ? 'strikethrough-text' : ''">
                        {{ personOtherContact.value }}
                      </span>
                    </span>
                  </div>
                  <!-- <div class="col-md-3">
                    <span class="regular-16">{{personOtherContact.contact_category}}</span>
                  </div>
                  <div class="col-md-6">
                    <div class="regular-16" v-if="personOtherContact.contact_type === 'Email'">
                      <a :href="'mailto:' + personOtherContact.value">{{ personOtherContact.value }}</a>
                    </div>
                    <div class="regular-16" v-else>
                      <span class="regular-16">{{personOtherContact.value}}</span>
                    </div>
                  </div> -->
                </div>
              </div>
              <div v-if="peopleData.person.person_inactive_contacts.length > 0" class="text-muted regular-14">
                <span>{{ peopleData.person.person_inactive_contacts.length }} deleted</span> |
                <span class="cursor-pointer person-contact-show" @click="showInactiveContacts = !showInactiveContacts">
                  {{ showInactiveContacts ? 'Hide' : 'Show' }}
                </span>
              </div>
            </b-card>
            <b-card>
              <div class="lyon-display-medium-24 mb-3">
                Mailing Addresses
                <a :href="fetchLegacyUrl(`/people/${$route.params.id}/addresses`)">
                  <i v-b-tooltip.hover class="fa fa-edit edit-icon" title="Edit/Add Addresses" />
                </a>
              </div>
              <div v-if="peopleData.person.mailing_address_id.length === 0">
                <span class="text-muted regular-14">No Mailing Address Information Provided</span>
              </div>
              <div v-else>
                <person-address :addresses="peopleData.person.mailing_addresses"
                                :preferred_address_type="peopleData.person.mailing_address_id.address_type" />
              </div>
            </b-card>
            <b-card>
              <div class="lyon-display-medium-24 mb-3">
                Current/Past Institutions
                <a :href="fetchLegacyUrl(`/people/${$route.params.id}/institutions`)">
                  <i v-b-tooltip.hover class="fa fa-edit edit-icon" title="Edit/Add Institutions" />
                </a>
              </div>
              <person-institution :person="peopleData.person" />
            </b-card>
            <b-card>
              <person-information :title="'Demographic'" :form-data="formDemographic" />
            </b-card>
            <b-card>
              <div class="lyon-display-medium-24 mb-3">Spouse</div>
              <div v-if="peopleData.person.spouse">
                <div v-if="peopleData.person.spouse.spouse_deceased && canEditCms"
                     class="px-2 badge regular-14 typo-color-white bg-danger">
                  DECEASED
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <span class="text-muted regular-16">
                      <span>Name</span>
                    </span>
                  </div>
                  <div class="col-md-8">
                    <span class="regular-16">
                      <span>{{ peopleData.person.spouse.spouse_full_name }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div v-else>
                <span class="text-muted regular-14">No Spouse Information Provided</span>
              </div>
            </b-card>
            <b-card>
              <person-information :title="'Education Information'" :form-data="formEducationInfo" />
            </b-card>
            <b-card>
              <person-information :title="'Employment Information'" :form-data="formEmploymentInfo" />
            </b-card>
            <div class="accordion" role="tablist">
              <b-card v-if="canEditCms">
                <b-card-header class="custom-card-header-event">
                  <div v-b-toggle.visa-accordion class="lyon-display-medium-21">Visa Applications</div>
                </b-card-header>
                <b-collapse id="visa-accordion" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <PersonVisaDetail :visas="peopleData.person.visas" />
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card v-if="canEditCms">
                <b-card-header class="custom-card-header-event">
                  <div v-b-toggle.housing-accordion class="lyon-display-medium-21">Housing Applications</div>
                </b-card-header>
                <b-collapse id="housing-accordion" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <PersonHousingDetail :housings="peopleData.person.housings" />
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <profile-tabs :person-data="peopleData.person" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonalDetailSection from "./PersonalDetailSection.vue"
import PersonAddress from "@/components/CommonPages/ProfileSection/PersonAddress.vue"
import PersonInformation from "@/components/CommonPages/ProfileSection/PersonInformation.vue"
import PersonInstitution from "@/components/CommonPages/ProfileSection/PersonInstitution.vue"
import router from "@/router"
import mixin from "@/utils/mixin.js"
import { mapGetters } from "vuex"
import UpdateEmailForm from "@/components/CommonPages/ProfileSection/UpdateEmailForm.vue"
import UpdatePasswordForm from "@/components/CommonPages/ProfileSection/UpdatePasswordForm.vue"
import UpdateORCIDForm from "@/components/CommonPages/ProfileSection/UpdateORCIDForm.vue"
import LineLoader from "@/components/Loaders/LineLoader.vue"
import PersonHousingDetail from "@/components/CommonPages/ProfileSection/PersonHousingDetail.vue"
import PersonVisaDetail from "@/components/CommonPages/ProfileSection/PersonVisaDetail.vue"
import ProfileTabs from "@/components/AboutUs/Directories/MemberDirectory/ProfileTabs/ProfileTabs.vue"

export default {
	name: "PersonalProfile",
	components: {
		LineLoader,
		PersonalDetailSection,
		PersonAddress,
		PersonInformation,
		PersonInstitution,
		UpdateEmailForm,
		UpdatePasswordForm,
		UpdateORCIDForm,
		PersonVisaDetail,
		PersonHousingDetail,
		ProfileTabs,
	},
	metaInfo: {
		title: "Personal Profile",
	},
	mixins: [mixin],
	data() {
		return {
			peopleData: null,
			loadingData: true,
			showInactiveContacts: false,
			personAllContacts: [],
		}
	},
	computed: {
		...mapGetters(["getDetailActiveTab", "canEditCms", "isAuthenticated", "authUser"]),
		formDemographic() {
			return [
				{
					label: "Gender",
					value: this.genderText(),
				},
				{
					label: "Ethnicity",
					value: this.peopleData.person.ethnicity,
				},
				{
					label: "Race",
					value: this.peopleData.person.race,
				},
				{
					label: "Citizenship",
					value: this.peopleData.person.citizenship,
				},
				{
					label: "Birth Date",
					value: this.peopleData.person.birth_date,
					onlyMsri: true,
				},
				{
					label: "Birth Place",
					value: this.peopleData.person.birth_place,
					onlyMsri: true,
				},
			]
		},
		formEducationInfo() {
			return [
				{
					label: "AMS Mathematics Subject Classification",
					value: this.peopleData.person.ams_subject_classification,
				},
				{
					label: "Highest Degree",
					value: this.peopleData.person.degree,
				},
				{
					label: "Highest Degree Year",
					value: this.peopleData.person.degree_year,
				},
				{
					label: "Habilitation Year",
					value: this.peopleData.person.habilitation_year,
				},
				{
					label: "PhD Year",
					value: this.peopleData.person.phd_year,
				},
				{
					label: "Highest Degree Institution",
					value: this.peopleData.person.institution_id?.name,
					href:
						this.peopleData.person.institution_id &&
						this.fetchLegacyUrl(`/institutions/${this.peopleData.person.institution_id.id}`),
				},
				{
					label: "Highest Degree Advisor",
					value: this.peopleData.person.degree_advisor,
				},
				{
					label: "Thesis Title",
					value: this.peopleData.person.degree_thesis,
				},
			]
		},
		formEmploymentInfo() {
			return [
				{
					label: "Field of Expertise",
					value: this.peopleData.person.math_interests,
					isArrayData: true,
				},
				{
					label: "Employment Type",
					value: this.peopleData.person.employment_type,
				},
				{
					label: "Tenure Status",
					value: this.peopleData.person.tenure_status,
				},
			]
		},
	},
	watch: {
		$route() {
			this.loadProfileData()
		},
		isAuthenticated() {
			this.loadProfileData()
		},
		showInactiveContacts(value) {
			this.personAllContacts = value
				? this.peopleData.person.person_active_contacts.concat(this.peopleData.person.person_inactive_contacts)
				: this.peopleData.person.person_active_contacts
		},
	},
	mounted() {
		this.checkIsOrcidSignUpFromRegistrationPage()
		this.loadProfileData()
	},
	methods: {
		loadProfileData() {
			this.$http.get(`${process.env.VUE_APP_API_URL}/people/${this.$route.params.id}.json`).then((res) => {
				if (res) {
					this.peopleData = res.data
					if (this.peopleData) this.personAllContacts = this.peopleData.person.person_active_contacts
					this.loadingData = false
				}
			})
		},
		checkIsOrcidSignUpFromRegistrationPage() {
			if (
				localStorage.getItem("isOrcidSignUpFromRegistrationPage") &&
				localStorage.getItem("isOrcidSignUpFromRegistrationPage") === "true"
			) {
				localStorage.setItem("isOrcidSignUpFromRegistrationPage", "false")
				window.close()
			}
		},
		reDirectTo() {
			router.push({ name: this.$route.query.reDirectFrom })
		},
		genderText() {
			const otherText = this.peopleData.person.gender_explanation_text
				? this.peopleData.person.gender_explanation_text
				: ""
			if (otherText) {
				return `${this.peopleData.person.gender} ${otherText}`
			}
			return this.peopleData.person.gender
		},
		updateEmailData(isHide) {
			if (isHide) {
				this.$refs.showUpdateEmailForm.hide()
			} else {
				this.$refs.showUpdateEmailForm.hide()
				this.loadProfileData()
			}
		},
		updatePasswordData() {
			this.$refs.showUpdatePasswordForm.hide()
		},
		updateORCIDData(isHide) {
			if (isHide) {
				this.$refs.showUpdateOrcidForm.hide()
			} else {
				this.$refs.showUpdateOrcidForm.hide()
				this.loadProfileData()
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.custom-card-header-event {
  background-color: #eeeeee !important;
  cursor: pointer !important;
}

.person-contact-show:hover {
  color: #8B00BC;
}
</style>
